/**
 * @generated SignedSource<<cc06a7e08a754ca4148e81e4487998b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SalesforceIntegrationQuery$variables = {};
export type SalesforceIntegrationQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"SalesforceIntegration_viewer">;
  };
};
export type SalesforceIntegrationQuery = {
  response: SalesforceIntegrationQuery$data;
  variables: SalesforceIntegrationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SalesforceIntegration_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SalesforceIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToCopilot",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasAccessToSalesforceFeature",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "salesforce_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"salesforce_integration\")"
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubspotAccountNode",
                    "kind": "LinkedField",
                    "name": "hubspot",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userConnected",
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesforceWorkspaceConfigurationNode",
                    "kind": "LinkedField",
                    "name": "salesforce",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "configurer",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesforceUserNode",
                "kind": "LinkedField",
                "name": "salesforce",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "autoSendNotesEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeRecapInAutoSendNotes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createInSalesforceAs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relateToOpportunity",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relateToAccount",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HubspotUserNode",
                "kind": "LinkedField",
                "name": "hubspot",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "79fcd775797687384e3b1420357f5ca7",
    "id": null,
    "metadata": {},
    "name": "SalesforceIntegrationQuery",
    "operationKind": "query",
    "text": "query SalesforceIntegrationQuery {\n  viewer {\n    ...SalesforceIntegration_viewer\n    id\n  }\n}\n\nfragment SalesforceIntegration_viewer on Viewer {\n  hasAccessToCopilot\n  account {\n    billingAccount {\n      hasAccessToSalesforceFeature: hasAccessToFeature(feature: salesforce_integration)\n      id\n    }\n    integrations {\n      hubspot {\n        userConnected\n        id\n      }\n      salesforce {\n        configurer {\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n  integrations {\n    salesforce {\n      isConnected\n      autoSendNotesEnabled\n      includeRecapInAutoSendNotes\n      createInSalesforceAs\n      relateToOpportunity\n      relateToAccount\n      id\n    }\n    hubspot {\n      isConnected\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "557d25b0dde8833762b5a59e32cbe5cc";

export default node;
